import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgEllipse = (props, ref) => /* @__PURE__ */ jsx("svg", { width: 6, height: 6, viewBox: "0 0 6 6", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props, children: /* @__PURE__ */ jsx("circle", { cx: 3, cy: 3, r: 3, fill: "inherit" }) });
const ForwardRef = forwardRef(SvgEllipse);
export { ForwardRef as ReactComponent };
